import _ from 'underscore'
import Backbone from 'backbone'
import RegisterViewTemplate from '../templates/register.tpl'
import messages from '../messages'
import user from '../user'
import FormView from './form'
import Translate from '../helpers/translate-data-attributes'
import config from '../config'
import Alert from '../helpers/alert'
import { Capacitor } from '@capacitor/core'

const RegisterView = FormView.extend({
    events: {
        'click .close' : 'close',
        'click .login' : 'login',
        'click .register' : 'register',
        'click .show-info.one' : 'showInfoOne',
        'click .show-info.two' : 'showInfoTwo',
        'click .check-one .radio' : 'checkOne',
        'click .check-two .radio' : 'checkTwo',
    },
    type: null,
    freeBook: false,
    ios: false,
    initialize(){
        this.template = _.template(RegisterViewTemplate)
        this.ios = Capacitor.getPlatform() === 'ios'
    },
    register() {
        const data = {
            promo: this.$el.find('#promo').val(),
            firstname: this.$el.find('#firstname').val(),
            lastname: this.$el.find('#lastname').val(),
            username: this.$el.find('#username').val(),
            password: this.$el.find('#password').val(),
            confirm_password: this.$el.find('#confirm-password').val(),
            pin: null,
            email: null,
        }

        if (this.type === 'student') {
            data.pin = this.$el.find('#pin').val()
        } else {
            data.email = this.$el.find('#email').val()
        }

        new Promise((resolve, reject) => {
            // check for any blank items
            for (const item in data) {
                if (item === 'promo') continue
                if (data[item] !== null && data[item].trim() === '') {
                    reject(Translate(item))
                }
            }
            resolve()
        })
            .then(() => {
                // check if the passwords match
                return new Promise((resolve, reject) => {
                    if (data.password === data.confirm_password) {
                        resolve()
                    } else {
                        reject(messages.MSG_PASSWORDS_DONT_MATCH)
                    }
                })
            })
            .then(() => {
                // register
                const attributes = {
                    firstname: data.firstname,
                    lastname: data.lastname,
                    username: data.username,
                    password: data.password,
                    type: this.type,
                    appId: config.get('id'),
                }

                if (this.type === 'student') {
                    attributes.schoolPin = data.pin
                } else {
                    attributes.email = data.email
                }

                return user.create(attributes)
            })
            .then(() => {
                // close
                return new Promise((resolve) => {
                    this.close()
                    resolve()
                })
            })
            .then(() => {
                // add promo
                return user.get('purchased').addPromo(data.promo)
            })
            .catch(Alert)
    },
    showInfoOne() {
        this.$el.find('.info.one').toggle()
    },
    showInfoTwo() {
        this.$el.find('.info.two').toggle()
    },
    checkOne(event) {
        const school = this.$(event.target).val()

        if (school === 'yes') {
            this.type = null
            this.$el.find('.check-two').show()
            this.$el.find('.check-three').hide()
        } else {
            this.type = 'individual'
            this.$el.find('.check-two').hide()
            this.$el.find('.check-three').show()
            this.$el.find('.pin').hide()
            this.$el.find('.email').show()
        }
    },
    checkTwo(event) {
        this.type = this.$(event.target).val()

        this.$el.find('.check-three').show()

        if (this.type === 'student') {
            this.$el.find('.pin').show()
            this.$el.find('.email').hide()
        } else {
            this.$el.find('.pin').hide()
            this.$el.find('.email').show()
        }
    },
    close() {
        const returnRoute = config.get('returnRoute')
        config.unset('returnRoute')
        Backbone.history.navigate(returnRoute || '', { trigger: true })
    },
    login() {
        Backbone.history.navigate('login', { trigger: true })
    }
})

export default RegisterView